export enum DictCodeEnmu {
	//加盟类型
	FRANCHISEE = 'franchisee',
	//经营性质
	BUSINESS_NATURE = 'business-nature',
	//加盟资质
	FRANCHISE_QUALIFICATION = 'franchise-qualification',
	// //加盟设备
	FRANCHISE_EQUIPMENT = 'franchise-equipment',
	// //人员储备
	PERSONNEL_RESERVES = 'personnel-reserves',
	//跟进方式
	FOLLOW_UP = 'follow-up',
	//意向程度
	INTENTION_LEVEL = 'Intention-level',




	// 消息预警类型
	WARNIMG_TYPE = "warning-type",
	// 消息预警类型-风险
	WARNING_TYPE_RISK = "warning-type.risk",
	// 消息预警类型-业务
	WARNING_TYPE_BUSINESS = "warning-type.business",



	// 消息预警类型
	BUSINESS_TYPE = "business-type",
	// 结算审核
	BUSINESS_TYPE_SETTLE_VERIFY = "business-type.settle.verify",


}